const validate = (val, field, rule) => {
  let isValid = true;

  switch (field) {
    case 'email':
      isValid = isValid && emailValidator(val);
      break;
    case 'text':
      isValid = isValid && minLengthValidator(val, rule);
      break;
    case 'number':
      isValid = isValid && minNumValidator(val, rule);
      break;
    case 'multiple':
      isValid = isValid && minLengthValidator(val, rule);
      break;
    default:
      isValid = isNotEmpty(String(val)) || !!val;
  }

  return isValid;
};

const isNotEmpty = (val) => val.length > 0;

const emailValidator = (val) =>
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
    val,
  );

const minLengthValidator = (val, minLength) => val.length >= minLength;
const minNumValidator = (val, minLength) => val >= minLength;

export default validate;
